import { TabBar } from '@ksyos/design-system';
import { styled } from 'styled-components';
import { getSelectedLanguage } from '@frontend/translate';
import { useNavigateInTabBar } from '@frontend/utils/hooks/useNavigateInTabBar';

export const DataChecksTabs = {
    organizationStats: 'organizationStats',
    organizations: 'organizations',
    practitioners: 'practitioners',
} as const;

export type DataChecksTabs = (typeof DataChecksTabs)[keyof typeof DataChecksTabs];

type DataChecksTabProps = {
    availableTabs: DataChecksTabs[];
    selectedTab: DataChecksTabs;
};

export function DataChecksTabBar({ availableTabs, selectedTab }: DataChecksTabProps): JSX.Element {
    const { organization } = getSelectedLanguage();
    const { setSelectedTab } = useNavigateInTabBar();

    return (
        <StyledTabBar>
            {availableTabs.map((tab) => (
                <TabBar.Button
                    isSelected={selectedTab === tab}
                    key={tab}
                    onClick={() => setSelectedTab(tab)}
                >
                    {organization[tab]}
                </TabBar.Button>
            ))}
        </StyledTabBar>
    );
}

const StyledTabBar = styled(TabBar)`
    margin-bottom: 24px;
`;
